<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
img {
  object-fit: cover;
}
.cart-page {
  padding: 24px;
  background-color: #f8f8fb;
  min-height: 100%;
  .un-select {
    width: 36px;
    height: 36px;
    border: 2px solid #1d1d1d;
    background-color: #ffffff;
    border-radius: 50%;
  }

  .cannot-select {
    width: 36px;
    height: 36px;
    border: 2px solid #cdcdd4;
    background-color: #e7e7f0;
    border-radius: 50%;
  }

  .cart-list {
    min-height: 100%;
    padding-bottom: 220px;
    .cart-item {
      margin-bottom: 24px;
      background-color: #ffffff;
      height: 200px;
      display: flex;
      // justify-content: center;
      align-items: center;
      padding: 24px;
      .select-icon-container {
        width: 40px;
        height: 40px;
      }
      .select-icon {
        width: 36px;
        height: 36px;
        display: block;
      }
      .product-image {
        margin-left: 24px;
        height: 76 * 2px;
        width: 76 * 2px;
        overflow: hidden;
        position: relative;
        img {
          height: 100%;
          width: 100%;
        }
        .sold-out {
          height: 88px;
          width: 88px;
          border-radius: 50%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          color: #ffffff;
        }
      }
      .product-msg {
        margin-left: 24px;
        flex: 1;
        .product-name {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          -webkit-line-clamp: 2;
        }
        .product-price {
          display: flex;
          align-items: flex-end;
          margin-top: 30px;
          .pre {
            color: #FF5572;
            font-size: 22px;
            font-weight: 600;
          }
          .price {
            color: #FF5572;
            font-size: 34px;
            font-weight: 800;
          }
        }
      }
    }
    .delete-area {
      width: 126px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ff5572;
      color: #ffffff;
    }

  }
  .cart-container {
    height: 204px;
    width: 100%;
    padding-bottom: 68px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 20px 24px;
    bottom: 0;
    left: 0;
    position: fixed;
    
    .select-content {
      height: 96px;
      display: flex;
      align-items: center;
      // justify-content: center;
      flex: 1;
      .select-icon {
        width: 36px;
        height: 36px;
      }
      .tips {
        margin-left: 24px;
        color: #2a2a30;
        font-size: 28px;
        font-weight: 500;
      }
    }
    .mount-content {
      display: flex;
      height: 96px;
      align-items: center;
      // margin-left: ;
      .pre {
        color: #FF5572;
        font-size: 28px;
        font-weight: 500;
        margin-left: 10px;
      }
      .price {
        color: #FF5572;
        font-size: 40px;
        font-weight: 500;
      }
    }
    .add-btn {
      width: 240px;
      height: 96px;
      background-color: #2a2a30;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 36px;
      font-weight: 500;
      margin-left: 24px;
    }
  }
  .no-data-container {
    padding-top: 312px;
    text-align: center;
    width: 100%;
    .tips {
      font-size: 28px;
      // width: 100%;
      color: #2a2a30;
      text-align: center;
    }
  }
}
</style>

<template>
  <div class="cart-page">
    <div class="cart-list" v-if="cartList.length > 0">
      <van-swipe-cell v-for="(product, idx) in cartList" :key="idx">
          <div class="cart-item"  @click="changeSelect(idx)">
            <div class="select-icon-container">
              <div v-if="product.status == 2" class="cannot-select"></div>
              <img v-else-if="product.selected" class="select-icon" src="https://oss.turingsenseai.com/1626766756639220820.png" />
              <div v-else class="un-select"></div>
            </div>
            <div class="product-image">
              <img :src="product.appearancePic" />
              <div v-if="product.status == 2" class="sold-out">失效</div>
            </div>
            <div class="product-msg">
              <div class="product-name">{{product.productName}}</div>
              <div class="product-price">
                <div class="pre">￥</div>
                <div class="price">{{product.price / 100}}</div>
              </div>
            </div>
          </div>
        <template #right>
          <div class="delete-area" @click="delProduct(product.pid,idx)">删除</div>
        </template>
      </van-swipe-cell>
    </div>

    <div v-else class="no-data-container">
      <div class="tips">暂无数据</div>
    </div>

    <div class="cart-container">
      <div class="select-content" @click="selectAll">
        <img v-if="this.selectedAll" class="select-icon" src="https://oss.turingsenseai.com/1626766756639220820.png" />
        <div v-else class="un-select"></div>
        <div class="tips">全选</div>
      </div>
      <div class="mount-content">
        <div class="tip">合计</div>
        <div class="pre">￥</div>
        <div class="price">{{totalMount / 100}}</div>
      </div>
      <div class="add-btn" @click="goPay">去结算</div>
    </div>
  </div>
</template>

<script>
import { fetchCartList, delCart, genOrder } from './../../../common/api/purchase'
import { SwipeCell, Toast } from 'vant'
export default {
  components: {
    'van-swipe-cell': SwipeCell
  },
  data() {
    return {
      cartList: [],
      selectedAll: false,
      totalMount: 0
    }
  },
  mounted () {
    this.getCartList()
  },
  methods: {
    getCartList() {
      fetchCartList()
        .then(res => {
          if (res && res.errorCode == 0) {
            if(this.cartList){
              for(let i=0;i<this.cartList.length;i++){
                if(this.cartList[i].selected){
                  res.cartList[i].selected=true
                }
              }
              this.cartList=res.cartList
            }else{
              this.cartList = res.cartList
            }
            // this.cartList = res.cartList
          }
        })
        this.totalMount = 0
        this.cartList.filter(item => item.selected).forEach(item => {
        this.totalMount += item.price
      })
    },
    changeSelect(idx) {
      if (this.cartList[idx].status == 2) return
      this.cartList[idx] && (this.cartList[idx].selected = !this.cartList[idx].selected)
      this.cartList = [...this.cartList]
      this.totalMount = 0
      this.cartList.filter(item => item.selected).forEach(item => {
        this.totalMount += item.price
      })
      //每次改变item的选择状态，都会校验一下是否全选
      let count=0;
      for(let i=0;i<this.cartList.length;i++){
        if(this.cartList[i].selected===true){
          count++
        }
      }
      if(count===this.cartList.length){
        this.selectedAll=true
      }else{
        this.selectedAll=false
      }
    },
    // 全选或全不选
    selectAll() {
      this.selectedAll = !this.selectedAll
      this.cartList.forEach(item => {
        if (item.status != 2 ) {
          item.selected = this.selectedAll
        }
      })
      this.totalMount = 0
      this.cartList.filter(item => item.selected).forEach(item => {
        this.totalMount += item.price
      })
    },
    delProduct(pid,idx) {
      this.cartList.splice(idx,1)
      delCart({ pids: pid }).then(res => {
        if (res && res.errorCode == 0) {
          Toast.success('从购物车移除成功')
          this.getCartList()
        }
      })
    },
    goPay() {
      const pidArr = this.cartList.filter(item => item.selected).map(item => item.pid)
      if (pidArr.length <= 0) {
        Toast.fail('尚未选择任何商品')
        return
      }

      genOrder({ pids: pidArr.join('-') })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.getCartList()
            this.$router.push({ path: `/purchase/pay-page?orderNo=${res.orderNo}&payMount=${this.totalMount / 100}` })
          }
        })
    }
  }
}
</script>